<template>
  <div>
      <div class="draw-events">
        <div v-for='result in $parent.getResultObjectEvents' :key='result._id' class="draw-events-flex-parent-container">
          <div class="draw-events-flex-container">
              <div>
                <span class="event-game-title-prefix">{{ result.eventNumber }}</span>
                <span class="event-game-title">{{ result.eventDescription }}</span>
              </div>
              <div>
                <div v-if="!result.cancelled" class="game-result-score">{{ result.outcomeScore.home }} - {{ result.outcomeScore.away }}</div>
                <div v-else class="game-result-cancelled">Lottad</div>
              </div>
              <div>
                <div>{{ result.outcome }}</div>
              </div>
          </div>
        </div>
      </div>

      <div class="turnover-container">
        Omsättning: {{ $parent.getResultTurnover }} kr
      </div>

      <div style="
          background-color: #e1e1e5;
          color: #111;
          position: relative;
          min-height: 40px;
          height: 40px;
          text-align: center;
          line-height: 40px;
      ">
      <span style="font-weight:bold;">Utdelning</span>
      </div>

      <div class="winner-container">
        <div class="distribution-payment-container" v-for='result in $parent.getDrawObject.result.distribution' :key='result._id'>
          <div>
            {{result.name}}
          </div>
          <div>
            {{ result.winners }} st
          </div>
          <div>
            {{ $parent.renderStyledAmount(result.amount) }} SEK
          </div>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  data: () => ({
    name: 'DrawResult',
  }),
  methods: {
    transalte(id) {
      let winners = 13;
      switch (id) {
        case 1:
          winners = '13';
          break;
        case 2:
          winners = '12';
          break;
        case 3:
          winners = '11';
          break;
        case 4:
          winners = '10';
          break;
        default:
      }
      return winners;
    }
  }
};
</script>

<style>
.distribution-payment-container {
  display: flex;
  flex-wrap: nowrap;
  font-size:11px;
}
.distribution-payment-container > div:first-child {
  min-width:50px;
}
.distribution-payment-container > div:nth-child(2) {
  white-space:nowrap;
  margin-left:auto;
  text-align:right;
  min-width:60px;
}
.distribution-payment-container > div:nth-child(3) {
  text-align:right;
  white-space:nowrap;
  margin-left:auto;
  min-width:80px;
}
.distribution-payment-container > div:last-child {
  white-space:nowrap;
  margin-left:auto;
}
</style>
